import { render, staticRenderFns } from "./Rekanan.vue?vue&type=template&id=29be2d5e"
import script from "./Rekanan.vue?vue&type=script&lang=js"
export * from "./Rekanan.vue?vue&type=script&lang=js"
import style0 from "./Rekanan.vue?vue&type=style&index=0&id=29be2d5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports